import React from 'react';
import { AccordionItem, AccordionHeader, AccordionBody, Alert } from 'reactstrap';

import VersionerCollaboratorList from '../../../collaborator/list';

const VersionerDocumentComparisonSidebarCollaboratorContainer = (props) => {
  const {
    collaborators,
    helpers: {
      isPortalContext
    },
    routes: {
      editThreadPath
    }
  } = props;

  return (
    <AccordionItem>
      <AccordionHeader targetId="3">
        <h2 className="fs-6 fw-bold mb-0 mr-2">
          <i className="fas fa-users mr-2"></i>
          Participantes
        </h2>
        {
          !isPortalContext && (
            <a href={editThreadPath}>
              <i className="fas fa-edit"></i>
            </a>
          )
        }
      </AccordionHeader>
      <AccordionBody
        accordionId="3"
      >
        {
          collaborators.length > 0 ? (
            <VersionerCollaboratorList
              collaborators={collaborators}
            />
          ) : (
            <Alert color="info">
              <strong>No se encontraron participantes para este proyecto.</strong>
              {
                !isPortalContext && (
                  <p>Si deseas agregar participantes, puedes hacer click <a href={editThreadPath} rel="noopener noreferrer" className="text-blue">aquí</a>.</p>
                )
              }
            </Alert>
          )
        }
      </AccordionBody>
    </AccordionItem>
  );
};

export default VersionerDocumentComparisonSidebarCollaboratorContainer;